/* eslint-disable @typescript-eslint/no-explicit-any */
export const gaEvent = (...args: any[]) => window.gaEvent?.(...args)

export const ga = ((...args: any[]) => (window.ga as any)?.(...args)) as typeof window.ga
